import { Activity, CircleCheck, Clock, Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

const CARDS = [
  { key: "total", label: "Total Pengaduan Masuk", icon: Inbox, iconCls: "bg-white/10 text-emerald-300", dark: true },
  { key: "menunggu", label: "Menunggu", icon: Clock, iconCls: "bg-amber-50 text-amber-600" },
  { key: "dalam_proses", label: "Pengaduan Diproses", icon: Activity, iconCls: "bg-blue-50 text-blue-600" },
  { key: "selesai", label: "Pengaduan Selesai", icon: CircleCheck, iconCls: "bg-emerald-50 text-emerald-600" },
];

export const StatsCards = ({ stats }) => (
  <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4" data-testid="stats-cards">
    {CARDS.map(({ key, label, icon: Icon, iconCls, dark }, i) => (
      <div
        key={key}
        style={{ animationDelay: `${i * 70}ms` }}
        className={cn(
          "fade-up rounded-2xl border p-4 transition-transform duration-300 hover:-translate-y-0.5 sm:p-5",
          dark ? "border-slate-800 bg-slate-900 text-white" : "border-slate-200 bg-white",
        )}
        data-testid={`stat-card-${key}`}
      >
        <span className={cn("flex h-9 w-9 items-center justify-center rounded-xl", iconCls)}>
          <Icon className="h-4 w-4" />
        </span>
        <p className="mt-4 font-heading text-3xl font-extrabold tracking-tight sm:text-4xl" data-testid={`stat-value-${key}`}>
          {stats ? stats[key] : "–"}
        </p>
        <p className={cn("mt-1 text-xs font-medium sm:text-sm", dark ? "text-slate-300" : "text-slate-500")}>{label}</p>
      </div>
    ))}
  </div>
);
